import React from 'react';

const GridLayout = ({ isDarkMode }) => {
    const baseCardClasses = `${isDarkMode ? 'bg-[#1a1a1a]' : 'bg-gray-100'}`;

    const gridItems = [
        // Row 1
        {
            content: (
                <span className="text-xl md:text-2xl bg-gradient-to-r from-pink-400 via-blue-400 to-blue-500 bg-clip-text text-transparent">
          nod
        </span>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },
        {
            content: (
                <div className="w-full h-full bg-gradient-to-br from-green-300 via-blue-500 to-purple-600 opacity-80" />
            ),
            className: "aspect-video rounded-lg overflow-hidden"
        },
        {
            content: (
                <span className="text-xs md:text-sm text-gray-400">Medium | 12 DP</span>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },
        {
            content: (
                <span className="text-xl md:text-2xl text-gray-200">❈</span>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },

        // Row 2
        {
            content: (
                <img
                    src="/api/placeholder/400/320"
                    alt="placeholder"
                    className="w-full h-full object-cover"
                />
            ),
            className: "aspect-video rounded-lg overflow-hidden"
        },
        {
            content: (
                <div className="w-16 md:w-20 h-8 md:h-10 border border-current rounded-lg flex items-center justify-center">
                    <span className="text-xs md:text-sm">design</span>
                </div>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },
        {
            content: (
                <div className="text-center font-mono space-y-1">
                    <div className="text-sm md:text-base">pushpalatha studio</div>
                    <div className="text-xs md:text-sm">brand design</div>
                </div>
            ),
            className: "col-span-2 rounded-lg flex items-center justify-center py-6 md:py-8"
        },

        // Row 3
        {
            content: (
                <span className="text-3xl md:text-4xl font-mono">M</span>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },
        {
            content: (
                <span className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          32
        </span>
            ),
            className: "aspect-video rounded-lg flex items-center justify-center"
        },
        {
            content: null,
            className: "aspect-video rounded-lg"
        },
        {
            content: null,
            className: "aspect-video rounded-lg bg-gradient-to-br from-purple-600 to-blue-600 opacity-90"
        }
    ];

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 -mx-4 md:-mx-32">
            {gridItems.map((item, index) => (
                <div
                    key={index}
                    className={`${baseCardClasses} ${item.className}`}
                >
                    {item.content}
                </div>
            ))}
        </div>
    );
};

export default GridLayout;